import { Dispatch } from 'redux';
import { loadApplication } from 'src/slice';
import auth from 'src/auth';

export default function initializeApplication({ dispatch }: { dispatch: Dispatch }) {
    if (auth.isLoggedIn()) {
        dispatch(loadApplication());
    }
}
